interface IDecimalProps {
  value: number | string
  appendText?: string
}

const Decimal = (props: IDecimalProps) => {
  return (
    <>
      {props.value === 0 || props.value
        ? props.value?.toString().replace(".", ",")
        : ""}
      {props.value === 0 || props.value ? props.appendText : ""}
    </>
  )
}

export default Decimal
